import { ALL_OPTION } from "utility/constants";

export const validateAgencyForm = (formFields) => {
  if (formFields.photo === "") {
    return "Photo required.";
  }

  if (
    formFields.cosNumber?.length > 2 &&
    !/^(09)\d{9}$/.test(formFields?.cosNumber)
  ) {
    return "Invalid cos contact number.";
  }

  return true;
};

export const getAgencySelectedPrograms = (formFields, programOptions) => {
  let program = [];

  if (formFields.programs.some((_program) => _program.value === ALL_OPTION)) {
    program = programOptions
      .filter((_program) => _program.value !== ALL_OPTION)
      .map((_program) => _program.value);
  } else {
    program = formFields.programs.map((_program) => _program.value);
  }

  return program;
};
